import { Component, OnInit, Inject } from '@angular/core';
import { MessageService } from '../../services/email.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 's18-email-dialog',
  templateUrl: './email-dialog.component.html',
  styleUrls: ['./email-dialog.component.scss']
})
export class EmailDialogComponent implements OnInit {
  groupId: number;
  playerId: number;
  groupEventId: number;

  constructor(
    private emailService : MessageService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<EmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.groupId = this.data.groupId;
    this.playerId = this.data.playerId;
    this.groupEventId = this.data.groupEventId;
  }

  close(){
    this.dialogRef.close();
  }

}
